var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGitCompareGradient = function SvgGitCompareGradient(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#gitCompareGradient_svg__a)",
    fillRule: "evenodd",
    d: "M14.36 1.015 10.765 4.61a.375.375 0 0 0 0 .53l3.595 3.595c.236.236.64.069.64-.265V6h1.5A1.5 1.5 0 0 1 18 7.5v8.442a3.376 3.376 0 0 0 1.125 6.558 3.375 3.375 0 0 0 1.125-6.558V7.5a3.75 3.75 0 0 0-3.75-3.75H15V1.28a.375.375 0 0 0-.64-.265M9 18v-2.47c0-.334.404-.501.64-.265l3.595 3.595a.375.375 0 0 1 0 .53L9.64 22.985A.375.375 0 0 1 9 22.72v-2.47H7.5a3.75 3.75 0 0 1-3.75-3.75V8.058A3.376 3.376 0 0 1 4.875 1.5 3.375 3.375 0 0 1 6 8.058V16.5A1.5 1.5 0 0 0 7.5 18zm10.125 0a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25M6 4.875a1.125 1.125 0 1 1-2.25 0 1.125 1.125 0 0 1 2.25 0",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gitCompareGradient_svg__a",
    x1: 12,
    x2: 12,
    y1: 0.905,
    y2: 23.095,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#389CEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6B00DE"
  })))));
};
export default SvgGitCompareGradient;